module.exports = __webpack_public_path__ + "img/pet-art-small.7f46700e.webp";